import './MetricValue.css';

const MetricValue = ({
  value,
  label,
  align = 'start',
  className = '',
  title,
}) => {
  if (label === undefined || label === null || label === '') {
    throw new Error('MetricValue requires a label.');
  }

  return (
    <div
      className={`rds-metric-value ${className}`.trim()}
      data-align={align}
      title={title}
    >
      <strong className="rds-metric-value__number">{value}</strong>
      <span className="rds-metric-value__label">{label}</span>
    </div>
  );
};

export default MetricValue;
